<template>
    <div class="management">
        <b-dropdown variant="primary" right text="Right align" no-caret toggle-class="project-show-custom-editor-file"
                    class="ellipsis-nav bordered-menu custom-editor-file-nav">
            <template #button-content>
                <i class="fas fa-fw fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item
                class="open-custom-editor-file"
                @click="openEditor">
                <i class="fas fa-folder-open fa-fw"></i>{{$t('common.open')}}
            </b-dropdown-item>

            <b-dropdown-item
                class="watch-custom-editor-file"
                @click="readCustomEditorFile"
                v-if="groupCustomEditorFileIn.editor_file && !['gd', 'mg', 'sp'].includes(groupCustomEditorFileIn.editor_file.editor_type)">
                <i class="fas fa-binoculars"></i>{{$t('common.view')}}
            </b-dropdown-item>

            <b-dropdown-item
                class="download-custom-editor-file"
                @click="downloadCustomEditorFile"
                target="_blank"
                v-if="hasFile && projectIn.project_custom_editor_files[0].editor_file.editor_type !== 'mg'">
                <i class="btn-download"></i>{{$t('common.download')}}
            </b-dropdown-item>

            <b-dropdown-item
                class="upload-custom-editor-file"
                @click="openUploadModal()">
                <i class="btn-upload"></i>{{$t('common.upload')}}
            </b-dropdown-item>
        </b-dropdown>

        <design-2021-project-custom-editor-file-upload-modal-component
            ref="upload-modal"
            :project-in="projectIn"
            :groupCustomEditorFileIn="groupCustomEditorFileIn">
        </design-2021-project-custom-editor-file-upload-modal-component>
    </div>
</template>

<script>
    import Design2021PaperActionplanUploadModalComponent
        from '../../paper/show/modals/design-2021-paper-actionplan-upload-modal-component.vue';
    import axios from 'axios';

    export default {
        name: 'design-2021-project-show-custom-editor-file-buttons-component',
        components: { Design2021PaperActionplanUploadModalComponent },
        props: {
            projectIn: {
                type: Object,
                required: true,
            },
            groupCustomEditorFileIn: {
                type: Object,
                required: true,
            },
        },

        computed: {
            hasFile() {
                return !!this.projectIn.project_custom_editor_files.find((file) => file.group_custom_editor_file_id === this.groupCustomEditorFileIn.id);
            }
        },

        methods: {
            openEditor() {
                window.location.href = this.routes.projectCustomEditorFileEdit(this.projectIn.id, this.groupCustomEditorFileIn.id)
            },
            readCustomEditorFile() {
                window.location.href = this.routes.projectCustomEditorFileRead(this.projectIn.id, this.groupCustomEditorFileIn.id)
            },
            downloadCustomEditorFile() {
                window.location.href = this.routes.projectCustomEditorFileDownload(this.projectIn.id, this.groupCustomEditorFileIn.id)
            },
            openUploadModal() {
                this.$refs['upload-modal'].show();
            },

            blabla(x = null) {

            }
        },
    };
</script>

<style scoped lang="scss">
    .open-custom-editor-file,
    .download-custom-editor-file,
    .upload-custom-editor-file,
    .plagiarism-custom-editor-file
    {
        i {
            color: $primary;
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .management {
        align-self: center;
        margin-left: auto;
    }
</style>